import React from 'react'
import {
    BackButton,
    Bloc,
    Button,
    Conditionnal,
    Header,
    ProgressBar,
} from '../ImportAll'

export default function Vue14() {
    return (
        <div>
            <Header
                title="J'estime mon prêt"
                subTitle="Quelle est la durée du prêt souhaitée ?"
            />
            <div className="Container">
                <div className="BackNavigationContainerLeft">
                    <BackButton />
                </div>
            </div>
            <div className="Container">
                <ProgressBar size={95} time={1} />
            </div>

            <div className="Container">
                <Bloc
                    key="key116"
                    selectable
                    linked_data_id="finance_duree_souhaite"
                    linked_data_value={120}
                    nbcolumn={3}
                    gauche
                    simpleDoubleWord
                    text1="10"
                    text2="ans"
                    height={100}
                />
                <Bloc
                    key="key117"
                    selectable
                    linked_data_id="finance_duree_souhaite"
                    linked_data_value={180}
                    nbcolumn={3}
                    milieu
                    simpleDoubleWord
                    text1="15"
                    text2="ans"
                    height={100}
                />
                <Bloc
                    key="key118"
                    selectable
                    linked_data_id="finance_duree_souhaite"
                    linked_data_value={240}
                    nbcolumn={3}
                    droit
                    simpleDoubleWord
                    text1="20"
                    text2="ans"
                    height={100}
                />
                <Conditionnal
                    linked_data_id="prj_usage"
                    isEqualTo
                    targetDataValueCompare="RES_PRINCIPALE"
                >
                    <Bloc
                        key="key119"
                        selectable
                        linked_data_id="finance_duree_souhaite"
                        linked_data_value={300}
                        nbcolumn={3}
                        gauche
                        simpleDoubleWord
                        text1="25"
                        text2="ans"
                        height={100}
                    />
                </Conditionnal>
            </div>

            <Conditionnal linked_data_id="finance_duree_souhaite" isNotEmpty>
                <div className="SubmitButtonContainer">
                    {' '}
                    <Button text="Suivant" targetView={16} />{' '}
                </div>
            </Conditionnal>
        </div>
    )
}
